import { Dialog, DialogTrigger } from '@/components/atoms/Dialog';
import { TermsDialogContent } from '@/containers/auth/terms-dialog-content';
import { SIGNUP_TERMS } from '@/constants/signup-terms';

const FOOTER_LINKS = [
  { label: '이용약관', termsIndex: 0 },
  { label: '개인정보처리방침', termsIndex: 1 },
  { label: '이벤트/프로모션 정보 선택', termsIndex: 2 },
];

const BUSINESS_INFO = [
  '서클플랫폼(주) 대표 : 최영우',
  '사업자 등록번호 : 557-87-02223',
  '통신판매 제2022-서울강남-01773호',
];

const CONTACT_INFO = [
  'contact : support@cplat.io (02-558-2166)',
  '서울특별시 강남구 테헤란로 151 6층 609호',
];

type FooterInfoLineProps = {
  className: string;
  items: string[];
};

const FooterInfoLine = ({ className, items }: FooterInfoLineProps) => {
  return (
    <p className={`flex flex-wrap gap-x-[8px] gap-y-[2px] break-keep ${className}`}>
      {items.map((item, index) => (
        <span key={item} className="inline-flex items-center">
          {item}
          {index < items.length - 1 && (
            <span className="ml-[8px] hidden text-gr-400 lg:inline">|</span>
          )}
        </span>
      ))}
    </p>
  );
};

const Footer = () => {
  return (
    <footer className="border-t border-gr-100 bg-gr-50 px-[20px] py-[24px] sm:px-[28px] 875:px-[40px] lg:px-[60px] lg:py-[32px]">
      <div className="flex w-full flex-col gap-[20px] lg:flex-row lg:items-start lg:justify-between lg:gap-[40px]">
        <div className="flex min-w-0 flex-col gap-[8px]">
          <FooterInfoLine
            className="text-[13px] font-medium leading-[20px] text-gr-600"
            items={BUSINESS_INFO}
          />
          <FooterInfoLine className="text-[13px] leading-[20px] text-gr-500" items={CONTACT_INFO} />
          <p className="text-[12px] leading-[18px] text-gr-400">
            ⓒ {new Date().getFullYear()} circleplatform. All rights reserved.
          </p>
        </div>

        <nav aria-label="푸터 약관">
          <ul className="flex flex-wrap gap-x-[8px] gap-y-[6px] text-[13px] font-medium text-gr-500 lg:justify-end lg:gap-x-[16px]">
            {FOOTER_LINKS.map(({ label, termsIndex }) => (
              <li key={termsIndex}>
                <Dialog>
                  <DialogTrigger
                    type="button"
                    className="flex min-h-[36px] items-center rounded-sm px-[8px] py-[6px] text-left leading-[18px] transition-colors hover:bg-gr-100 hover:text-gr-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-point-500"
                  >
                    {label}
                  </DialogTrigger>
                  <TermsDialogContent content={SIGNUP_TERMS[termsIndex].termsContent} />
                </Dialog>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
